export default __webpack_public_path__ + "static/media/img3.31fc6fd7.png";